import { createContext } from "solid-js";

export class SolidFramework {
    events: Record<string, any> = {}
}

export const SolidFrameworkContext = createContext(new SolidFramework());

export class ExposeInternals {
    /** Provide a way to interface with a component from an external application.
     *  This will not work properly if this object is overwritten.
     *  Instead, only add properties to it */
    iface?: any = {}
}
